module.exports = __webpack_public_path__ + "img/Butterfly_00036.e25ec5e3.png";